import styled from "styled-components";

export const StyledWebInvoice = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${props => props.theme.C_BG_floorplan};
`;